const C = {
  name: "PersonCircle",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 5C9.79086 5 8 6.79086 8 9C8 11.2091 9.79086 13 12 13C14.2091 13 16 11.2091 16 9C16 6.79086 14.2091 5 12 5ZM10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9Z" fill="currentColor"/>
<path d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 13.8116 3.53527 15.4983 4.45629 16.9103C5.24766 15.1925 6.98457 14 9 14H15C17.0154 14 18.7523 15.1925 19.5437 16.9103C20.4647 15.4983 21 13.8116 21 12C21 7.02944 16.9706 3 12 3ZM12 21C14.2988 21 16.3964 20.1381 17.9871 18.7199C17.8458 17.1944 16.5624 16 15 16H9C7.43761 16 6.15418 17.1944 6.01291 18.7199C7.60363 20.1381 9.70116 21 12 21Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as PersonCircle
};
